<template>
	<div>
		<bsh-datatable 
			:columns="columns"
            :buttons="buttons" 
			:link="$url+'/api/adm/itens/datatable/'+$route.params.id"
            actionFild
            @selectRow="show"
            @show="show"
            @nextEstagio="nextEstagio"
			sorting
            ref="datatable">
		</bsh-datatable>
		<item-finalize-quantity 
			:item-id="selectedItemId" 
			@reload="reloadTable">
		</item-finalize-quantity>
	</div>
</template>

<script>
export default {
	data(){
		return {
            dados: [],
            selectedItemId: null,
            columns: [
                {
                    label: 'Produto',
                    field: 'produto',
                    order: 'produtos.nome',
                    sort: 'asc'
                },
                {
                    label: 'Quantidade',
                    field: 'quantidade',
                    sort: 'asc'
                },
                {
                    label: 'Estágio',
                    field: 'estagio_badge',
                    order: 'estagios.nome',
                    sort: 'asc'
                },
                {
                    label: 'Finalizados',
                    field: 'quantidade_finalizada',
                    sort: 'asc'
                },
                {
                    label: 'Progresso',
                    field: 'progress_bar',
                    noSorting: true
                },
                {
                    label: 'Valor Unidade',
                    field: 'valor_br',
                    order: 'itens.valor',
                    sort: 'asc'
                },
                {
                    label: 'Desconto Unidade',
                    field: 'desconto_br',
                    order: 'itens.desconto',
                    sort: 'asc'
                },
                {
                    label: 'Valor Total',
                    field: 'valor_total',
                    noSorting: true
                }
            ],
            buttons: [
                {
                    action: 'show',
                    classe: 'btn btn-primary',
                    iconClass: 'fas fa-eye',
                    title: 'Ver'
                },
                {
                    action: 'nextEstagio',
                    visible: (row) => {
                        const pedidoEstagioId = Number(row.pedido_estagio_id || (row.pedido ? row.pedido.estagio_id : (this.dados ? this.dados.estagio_id : 0)));
                        const itemEstagioId = Number(row.estagio_id);
                        return pedidoEstagioId === 2 && itemEstagioId < 3;
                    },
                    classe: (row) => {
                        const estagioId = Number(row.estagio_id);
                        if (estagioId === 1) return 'btn btn-primary';
                        if (estagioId === 2) return 'btn btn-success';
                        return 'btn btn-secondary';
                    },
                    iconClass: (row) => {
                        const estagioId = Number(row.estagio_id);
                        if (estagioId === 1) return 'fas fa-wrench';
                        if (estagioId === 2) return 'fas fa-check';
                        return '';
                    },
                    title: (row) => {
                        const estagioId = Number(row.estagio_id);
                        if (estagioId === 1) return 'Iniciar Produção';
                        if (estagioId === 2) return 'Finalizar';
                        return '';
                    }
                }
            ]
    	}
	},
    created(){
        this.getDados();
    },
    methods: {
        show(dado){
            this.$emit('show', dado.id);
        },
        nextEstagio(row){
            const estagioId = Number(row.estagio_id);
            const quantidade = Number(row.quantidade);
            const quantidadeFinalizada = Number(row.quantidade_finalizada);

            if (estagioId === 2 && quantidade > 1 && quantidadeFinalizada < quantidade) {
                this.selectedItemId = row.id;
                $('#update_quantidade_finalizada').modal('show');
            } else {
                var config = {
                    position: 'bottom-right',
                };
                axios.put(this.$url + '/api/adm/itens/next-estagio/' + row.id)
                    .then(response => {
                        this.$bshMessage.show(response.data.message, response.data.type, config);
                        this.reloadTable();
                    })
                    .catch(error => {
                        if (error.response && error.response.data && error.response.data.message) {
                            this.$bshMessage.show(error.response.data.message, 'error');
                        } else {
                            this.$bshMessage.show('Erro ao avançar estágio do item.', 'error');
                        }
                    });
            }
        },
        reloadTable(){
            if (this.$refs.datatable && this.$refs.datatable.getDados) {
                this.$refs.datatable.getDados();
            }
            this.getDados();
            this.$emit('reload');
        },
        getDados(){
            axios.get(this.$url+'/api/adm/pedidos/show/'+this.$route.params.id)
            .then(response => {
                this.dados = response.data.data || response.data
                this.checkColumns()
            })
            .catch(error => {
                console.log(error)
            });
        },
        checkColumns(){
            this.setColumns()
        },
        setColumns(){
            this.columns = [
                {
                    label: 'Produto',
                    field: 'produto',
                    order: 'produtos.nome',
                    sort: 'asc'
                },
                {
                    label: 'Quantidade',
                    field: 'quantidade',
                    sort: 'asc'
                },
                {
                    label: 'Estagio',
                    field: 'estagio_badge',
                    order: 'estagios.nome',
                    sort: 'asc'
                },
                {
                    label: 'Finalizados',
                    field: 'quantidade_finalizada',
                    sort: 'asc'
                },
                {
                    label: 'Progresso',
                    field: 'progress_bar',
                    noSorting: true
                },
                {
                    label: 'Valor Unidade',
                    field: 'valor_br',
                    order: 'itens.valor',
                    sort: 'asc'
                },
                {
                    label: 'Desconto Unidade',
                    field: 'desconto_br',
                    order: 'itens.desconto',
                    sort: 'asc'
                },
                {
                    label: 'Valor Total',
                    field: 'valor_total',
                    noSorting: true
                },
            ]
        }
    }
}
</script>